import { bounceMessage } from "../../../../../../../layout/userMessages/UserMessage";
import {getPriceGroupImpact, deletePriceGroup as deletePriceGroupAction} from '../../../../../../../redux/subscription/subscriptionActions';

// This function is intended for deleting a price group in the price groups screen
export  const deletePriceGroup = async (priceGroupId: number, handleRemovePriceGroup, t) => {
    try {
        // Get impact info to check how many series are affected
        const impactInfo = await getPriceGroupImpact(priceGroupId);
        const affectedCount = impactInfo?.affectedPlans || 0;

        // If no series are affected, delete directly without confirmation
        if(affectedCount === 0) {
            await deletePriceGroupAction(priceGroupId);
            handleRemovePriceGroup(priceGroupId);
            return;
        }

        // Show confirmation message with affected count
        bounceMessage(
            t('priceGroupDeleteWarning', {count: affectedCount}),
            'choice',
            {
                text: t('continue'),
                onClick: async () => {
                    // Perform actual deletion
                    await deletePriceGroupAction(priceGroupId);
                    // Remove from form if selected
                    handleRemovePriceGroup(priceGroupId);
                }
            },
            {
                text: t('cancel')
            }
        );
    } catch (error) {
        console.error('Error deleting price group:', error);
    }
};